import {
  CasDisplayField,
  CasRHFAutocompleteAsync,
  CasStackRow,
} from 'src/compass/shared/components';
import { Terms } from 'src/compass/shared/util/terms';
import { IGeneralObjectType } from 'src/compass/site/util';

type AccountFormProps = {
  row: IGeneralObjectType;
  // Rendered at the right of the first row (e.g. the Commissions link).
  headerAction?: React.ReactNode;
};

export default function AccountForm({ row, headerAction }: AccountFormProps) {
  return (
    <>
      {/* alignItems="center" is only on the action's own row - on the outer row it would apply
          control-no-margin, which strips the display fields' bottom margin. */}
      <CasStackRow justifyContent="space-between">
        <CasStackRow>
          <CasDisplayField label="Acct Name" value={row?.company} />
          <CasDisplayField label="Account#" value={row?.accountNumber} />
        </CasStackRow>
        {headerAction && <CasStackRow alignItems="center">{headerAction}</CasStackRow>}
      </CasStackRow>
      <CasRHFAutocompleteAsync
        url="Utilities/Entity/List"
        name="entityObj"
        label={Terms.Customer.label}
      />
      <CasRHFAutocompleteAsync
        url="Hubspot/Deals/List"
        name="crmDealObj"
        label={`${Terms.CRM.label} Deal`}
      />
    </>
  );
}
